<template>
  <div>
    <div class="inquiry">
      <div class="icon-help">
        <img src="../../../images/project-img/Icon-help-circle.svg" alt="Icon help" />
      </div>
      <div class="inquiry-box">
        <p>
          {{ description }} <a href="#" @click.prevent="toggleForm">{{ mailText }}</a>
        </p>

        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" :viewBox="viewBox">
            <g
              id="Arrow-Small_down"
              data-name="Arrow-Small down"
              transform="translate(0 10.2) rotate(-90)"
            >
              <path
                id="Arrow-Small_down-2"
                data-name="Arrow-Small down"
                d="M4.338.9A1,1,0,0,1,5.862.9L8.8,4.352A1,1,0,0,1,8.038,6H2.162A1,1,0,0,1,1.4,4.352Z"
                transform="translate(10.2 6) rotate(180)"
                fill="#ffffff"
              />
            </g>
          </svg>
        </span>
      </div>
    </div>
    <form
      class="form-contact"
      :class="{ 'd-none': !isFormVisible }"
      action="/api/find-info"
      method="POST"
      @submit="handleSubmit"
      ref="contactForm"
    >
      <div class="text-align-right close-form" @click="toggleForm">
        <img src="../../../images/project-img/close.svg" width="14" alt="Chiudi form" />
      </div>

      <div class="label">
        <label>
          Indicaci i tuoi dati e ti risponderemo al più presto.
        </label>
      </div>

      <template>
        <div class="form-group">
          <div class="input-group">
            <label for="contact_name">Nome</label>
            <input
              type="text"
              name="contact_name"
              id="contact_name"
              placeholder="Nome"
              v-model.trim="name"
              required
            />
          </div>
          <div class="input-group">
            <label for="contact_surname">Cognome</label>
            <input
              type="text"
              name="contact_surname"
              id="contact_surname"
              placeholder="Cognome"
              v-model.trim="surname"
              required
            />
          </div>
          <div class="input-group">
            <label for="contact_email">Email</label>
            <input
              type="email"
              name="contact_email"
              id="contact_email"
              placeholder="Email"
              v-model.trim="email"
              required
            />
          </div>
          <div class="input-group">
            <label
              for="verify_email"
              :class="{
                'text-red': showValidation && emailMismatch,
                'text-green': showValidation && emailMatch,
              }"
            >
              {{ showValidation && emailMismatch ? 'La mail non corrisponde' : 'Verifica Email' }}
            </label>
            <input
              type="email"
              name="verify_email"
              id="verify_email"
              placeholder="Verifica Email"
              v-model.trim="verifyEmail"
              @paste.prevent
              @blur="onVerifyBlur"
              required
            />
          </div>
          <div class="input-group">
            <label for="contact_plate">Targa</label>
            <input
              type="text"
              name="plate"
              id="contact_plate"
              placeholder="Targa"
              class="text-transform-uppercase"
              v-model.trim="plate"
              required
              maxlength="7"
            />
          </div>
        </div>

        <label for="contact_textarea" class="label-textarea">Messaggio</label>
        <textarea
          name="contact_textarea"
          id="contact_textarea"
          rows="6"
          placeholder="Il tuo messaggio"
          maxlength="1000"
          v-model.trim="contactMessage"
          required
        ></textarea>
        <div class="remaining_characters">{{ remainingCharacters }} rimanenti</div>

        <div class="text-align-right">
          <button
            :class="['button-primary mt-10', { 'button-disabled': !formValid }]"
            type="submit"
            :disabled="!formValid"
          >
            <template v-if="!loading">
              <span>Invia</span>
            </template>
            <loader v-else size="20px" />
          </button>
        </div>
      </template>
    </form>

    <!-- alert -->
    <sw-alert
      :show="showAlert"
      :type="alertType"
      :title="alertTitle"
      :text="alertText"
      @close="resetAlert"
    />
  </div>
</template>

<script>
import SwAlert from './SwAlert.vue';
import Loader from './Loader.vue';

export default {
  name: 'Inquiry',
  props: {
    description: {
      type: String,
      default: 'Qualcosa è andato storto?',
    },
    textMailTo: {
      type: String,
      default: 'Scrivici',
    },
  },
  data() {
    return {
      isFormVisible: false,
      name: '',
      surname: '',
      email: '',
      verifyEmail: '',
      verifyBlurred: false,
      plate: '',
      contactMessage: '',
      maxCharacters: 1000,
      showAlert: false,
      alertType: 'success',
      alertTitle: '',
      alertText: '',
      loading: false,
      viewBox: '0 0 6 7',
    };
  },
  computed: {
    mailText() {
      return `${this.textMailTo}`;
    },
    remainingCharacters() {
      return this.maxCharacters - this.contactMessage.length;
    },
    showValidation() {
      return this.verifyBlurred;
    },
    emailMismatch() {
      return this.verifyEmail !== this.email;
    },
    emailMatch() {
      return this.verifyEmail !== '' && this.verifyEmail === this.email;
    },
    formValid() {
      return (
        this.name &&
        this.surname &&
        this.email &&
        this.verifyEmail &&
        this.plate &&
        this.contactMessage &&
        this.emailMatch
      );
    },
  },
  methods: {
    updateViewBox() {
      this.viewBox = window.matchMedia('(max-width: 768px)').matches ? '0 0 8 7' : '0 0 6 7';
    },
    toggleForm() {
      this.isFormVisible = !this.isFormVisible;
    },
    onVerifyBlur() {
      this.verifyBlurred = true;
    },
    redirectToLogin() {
      window.location.href = '/auth/domus';
    },
    async handleSubmit(event) {
      event.preventDefault();
      this.loading = true;
      if (!this.formValid) {
        this.showAlert = true;
        this.alertType = 'error';
        this.alertTitle = 'Errore';
        this.alertText = 'Compila tutti i campi correttamente.';
        return;
      }

      const form = this.$refs.contactForm;
      const formData = new FormData(form);

      try {
        const response = await fetch(form.action, {
          method: form.method,
          body: formData,
        });

        this.showAlert = true;

        if (response.ok) {
          this.alertType = 'success';
          this.alertTitle = 'Grazie per la segnalazione!';
          this.alertText = 'Sarai contattato al più presto dalla nostra assistenza';
        } else {
          this.alertType = 'error';
          this.alertTitle = 'Errore';
          this.alertText = "Errore nell'invio del messaggio";
        }
      } catch (error) {
        this.showAlert = true;
        this.alertType = 'error';
        this.alertTitle = 'Errore';
        this.alertText = "Errore nell'invio del messaggio";
      }

      this.resetForm();
    },
    resetForm() {
      this.name = '';
      this.surname = '';
      this.email = '';
      this.verifyEmail = '';
      this.verifyBlurred = false;
      this.plate = '';
      this.contactMessage = '';
      this.isFormVisible = false;
      this.loading = false;
    },
    resetAlert() {
      this.showAlert = false;
    },
  },
  mounted() {
    this.updateViewBox();
    window.addEventListener('resize', this.updateViewBox);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateViewBox);
  },
};
</script>

<style scoped>
.form-contact:before {
  content: '';
  display: block;
  width: 30px;
  height: 30px;
  background: #efefef;
  transform: rotate(45deg);
  position: absolute;
  top: -15px;
  left: 50%;

  @media (max-width: 768px) {
    left: 75%;
  }
}

.form-group {
  margin-bottom: 20px;
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.form-group input {
  background: #ffffff 0% 0% no-repeat padding-box;
  padding: 10px;
  border: 1px solid #b1b1b1;
  border-radius: 4px;
  font: normal normal normal 14px / 19px Montserrat;
  letter-spacing: 0px;
  color: #444;
  outline: none;
}

.form-group input::placeholder {
  color: #b1b1b1;
}

.input-group {
  display: flex;
  flex-direction: column;
  width: 18%;

  @media (max-width: 768px) {
    width: 100%;
  }
}

.input-group label {
  font-size: 13px;
  margin-bottom: 3px;
}

.label-textarea {
  font-size: 13px;
  margin-bottom: 5px;
}

#contact_textarea {
  color: #444;
}

#contact_textarea::placeholder {
  color: #b1b1b1;
}

.text-red {
  color: #d20b12;
}

.text-green {
  color: #218c74;
}

.button-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/Inquiry.vue